<template>
  <div>
    <avs-title
      class="ml-2 mt-1"
      :text="companyName"
    />

    <v-tabs v-model="tab">
      <v-tab
        v-for="item in tabs"
        :key="item"
        @change="changeTable(item)"
      >
        {{ item }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item key="Projects">
        <v-data-table
          :loading="loading"
          :headers="headersProjects"
          :items="projects"
          loading-text="Loading projects..."
          no-data-text="No projects found"
          disable-pagination
          hide-default-footer
          class="elevation-1 mt-5"
        >
          <template #item.created_at="{ item }">
            {{ toDatetime(item.created_at) }}
          </template>
          <template #item.start_date="{ item }">
            {{ toDatetime(item.start_date) }}
          </template>
          <template #item.end_date="{ item }">
            {{ toDatetime(item.end_date) }}
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item key="Users">
        <v-data-table
          :loading="loading"
          :headers="headersUsers"
          :items="users"
          loading-text="Loading users..."
          no-data-text="No users found"
          disable-pagination
          hide-default-footer
          class="elevation-1 mt-5"
        >
          <template #item.date_joined="{ item }">
            {{ toDatetime(item.date_joined) }}
          </template>
          <template #item.last_login="{ item }">
            {{ toDatetime(item.last_login) }}
          </template>

          <template v-slot:item.connexion_status="{ item }">
            <v-icon
              large
              :color="getConnexionStatusColor(item.connexion_status)"
              >mdi-circle-medium</v-icon
            >
            {{ item.connexion_status }}
          </template>
          <template #item.is_active="item">
            <v-switch
              v-model="item.item.is_active"
              :label="item.item.is_active ? 'Active' : 'Disabled'"
              @click="handleActivation(item.item)"
            ></v-switch>
          </template>
        </v-data-table>
      </v-tab-item>

      <v-tab-item key="Pending invitations">
        <v-data-table
          :headers="headersInvitations"
          :items="pending_invitations"
          loading-text="Loading pending invitations..."
          no-data-text="No pending invitations found"
          disable-pagination
          hide-default-footer
          class="elevation-1 mt-5"
        >
          <template v-slot:item.resend="{ item }">
            <v-btn
              @click="inviteUser(item)"
              color="primary"
              fab
              text
            >
              <v-icon>mdi-email</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>
    <v-dialog
      v-model="dialogActivation"
      width="500"
      height="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          Activation
          <v-spacer></v-spacer>
          <v-btn
            fab
            text
            @click="handleClose"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text
          v-if="!chosenUser.is_active"
          class="text-h6 text-subtitle font-weight-bold py-2 mt-10"
          align="center"
          >Do you want to disable {{ fullName }}'s account ?
        </v-card-text>

        <v-card-text
          v-else
          class="text-h6 text-subtitle font-weight-bold py-2 mt-10"
          align="center"
          >Do you want to reactivate {{ fullName }}'s account ?
        </v-card-text>

        <v-card-actions
          class="justify-center mt-10"
          v-if="!chosenUser.is_active"
        >
          <v-btn
            :style="{
              paddingLeft: '80px',
              paddingRight: '80px'
            }"
            text
            x-large
            class="mb-10 blue white--text"
            @click="confirmActivation"
          >
            Disable
          </v-btn>
        </v-card-actions>

        <v-card-actions
          class="justify-center mt-10"
          v-else
        >
          <v-btn
            :style="{
              paddingLeft: '80px',
              paddingRight: '80px'
            }"
            text
            x-large
            class="mb-10 blue white--text"
            @click="confirmActivation"
          >
            Reactivate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AdminServices from "@/services/AdminServices"
import { toDatetime } from "@/utils/datetime"

export default {
  name: "CompanyPlans",
  data() {
    return {
      tabs: ["Projects", "Users", "Pending invitations"],
      headersProjects: [
        { text: "Name", align: "start", value: "name" },
        { text: "Creation date", align: "center", value: "created_at" },
        { text: "Start date", align: "center", value: "start_date" },
        { text: "End date", align: "center", value: "end_date" },
        { text: "Activities", align: "center", value: "nb_activities" },
        { text: "Tasks", align: "center", value: "nb_tasks" },
        { text: "Project Status", align: "center", value: "project_status" },
        { text: "Project Progress", align: "center", value: "project_progress" },
        { text: "Users", align: "center", value: "nb_users" },
        { text: "Operators", align: "center", value: "nb_operators" },
        { text: "Inspections", align: "center", value: "nb_inspections" },
        { text: "NC", align: "center", value: "nb_non_conformities" },
        { text: "Documents", align: "center", value: "nb_documents" },
        { text: "Data used", align: "center", value: "data_used" }
      ],
      headersUsers: [
        { text: "Name", align: "start", sortable: true, value: "email" },
        { text: "Role", align: "center", value: "company_role" },
        { text: "Date joined", align: "center", value: "date_joined" },
        { text: "Last login", align: "center", value: "last_login" },
        { text: "Connexion status", align: "center", value: "connexion_status" },
        { text: "Projects", align: "center", value: "nb_projects" },
        { text: "Data used", align: "center", value: "data_used" },
        { text: "Status", align: "center", value: "is_active" }
      ],
      headersInvitations: [
        { text: "Name", align: "start", sortable: true, value: "invitee_identifier" },
        { text: "Role", align: "center", value: "user_role" },
        { text: "Resend invitation", align: "center", value: "resend" }
      ],

      projects: [],
      users: [],
      pending_invitations: [],
      companyId: null,
      companyName: null,
      tab: null,
      loading: false,
      dialogActivation: false,
      chosenUser: {
        is_active: true
      }
    }
  },
  computed: {
    fullName: {
      get: function () {
        return this.chosenUser.first_name + " " + this.chosenUser.last_name
      }
    }
  },

  mounted() {
    this.companyId = this.$route.params.id
    this.companyName = this.$route.params.name
    AdminServices.getCompanyProjects(this, this.companyId).then(r => {
      this.projects = r.results
    })
  },
  methods: {
    toDatetime,
    changeTable(item) {
      if (item === "Projects") {
        this.loading = true
        AdminServices.getCompanyProjects(this, this.companyId)
          .then(r => {
            this.projects = r.results
          })
          .finally(() => {
            this.loading = false
          })
      }
      if (item === "Users") {
        this.loading = true
        AdminServices.getCompanyUsers(this, this.companyId)
          .then(r => {
            this.users = r.results
          })
          .finally(() => {
            this.loading = false
          })
      }
      if (item === "Pending invitations") {
        this.loading = true
        AdminServices.getPendingInvitations(this, this.companyId)
          .then(r => {
            this.pending_invitations = r.results
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    inviteUser(item) {
      let res = null
      if (item.user_role === "inspector") {
        res = [
          {
            privileges: {
              inspector: true,
              operator: false
            },
            email: item.invitee_identifier
          }
        ]
      } else if (item.user_role === "operator") {
        res = [
          {
            privileges: {
              inspector: false,
              operator: true
            },
            email: item.invitee_identifier
          }
        ]
      }
      AdminServices.inviteMember(this, this.companyId, res)
    },
    getConnexionStatusColor(status) {
      if (status === "connected") {
        return "success"
      }
      if (status === "connected one time") {
        return "warning"
      }
      if (status === "never connected") {
        return "error"
      } else {
        return
      }
    },
    /**
     * closing dialog activation, handling the is_active attribute of the company
     */
    handleClose() {
      this.dialogActivation = false
      this.chosenUser.is_active = !this.chosenUser.is_active
    },
    /**
     * handles the dialog activation with dialogActivation
     * @param user selected user that we want to change activation
     */
    handleActivation(user) {
      this.chosenUser = user
      this.dialogActivation = true
    },
    /**
     * handles the confirmation of the dialog activation to activate or disable a user account
     */
    confirmActivation() {
      const $ = this
      let data = {
        is_active: this.chosenUser.is_active
      }
      AdminServices.updateUserStatus(this, this.chosenUser.id, data).then(r => {
        this.loading = true
        AdminServices.getCompanyUsers($, this.companyId)
          .then(r => {
            this.users = r.results
          })
          .finally(() => {
            this.loading = false
            this.dialogActivation = false
          })
      })
    }
  }
}
</script>
